"use client";
import type { IResource } from "@gettactic/api";
import React from "react";
import { RoomSelectionRow } from "./RoomSelectionRow";

export interface RoomSelectionListProps {
  /** All rooms of the reservation, in map-numbering order (viewing room first). */
  rooms: IResource[];
  viewingRoomId: string | undefined;
  onView: (room: IResource) => void;
  onRemove: (roomId: string) => void;
}

const classes = {
  Wrapper: "flex flex-col gap-2",
  Heading: "font-bold font-inter text-[15px]",
  List: "flex flex-col gap-1"
};

/**
 * The rooms of a multi-room reservation. Renders nothing for a single room — that one is
 * already described by the card header.
 */
export const RoomSelectionList: React.FC<RoomSelectionListProps> = ({
  rooms,
  viewingRoomId,
  onView,
  onRemove
}) => {
  if (rooms.length < 2) {
    return null;
  }

  return (
    <div className={classes.Wrapper}>
      <h3 className={classes.Heading}>Rooms · {rooms.length}</h3>
      <div className={classes.List}>
        {rooms.map((room) => (
          <RoomSelectionRow
            key={room.id}
            room={room}
            isViewing={room.id === viewingRoomId}
            onView={onView}
            onRemove={onRemove}
          />
        ))}
      </div>
    </div>
  );
};
